import { ContainerModule } from 'inversify';
import { FileBankService, FileBankServiceSymbol } from '@/app/file/file-bank-service';

export const fileBankModule = new ContainerModule((bind) => {
  bind<FileBankService>(FileBankServiceSymbol).to(FileBankService);
});
